export const LOGIN = 'LOGIN';

export const LOGOUT = 'LOGOUT';

export const USERNAME = 'USERNAME'

export const USERID = 'USERID'


// WEBPACK FOOTER //
// ./src/store/types.js